import React from 'react';
import Helmet from 'react-helmet';
import { Fade } from 'react-reveal';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import config from '../../config/SiteConfig';
import SEO from '../components/SEO/SEO';
import Footer from '../components/Footer/Footer';
import Container from '../components/Container/Container';
import Hero from '../components/Hero/hero';
import styles from './page.module.scss';

const Page = () => {
  return (
    <div className="container project-container">
      <Helmet title={`${config.siteTitle}`} />
      <div className={styles.headerWrapper}>
        <Hero cover="../pictures/aero/hero.jpg" title="Aero Bike" link="#content" />
      </div>
      <div style={{ display: `flex`, flexDirection: `row` }}>
        <p id="content" style={{ width: `30%`, marginLeft: `18%` }}>
          AERO bicycle is a brand established by Digital Architects and Martino Hutz. Originally designed during their
          work at Studio Zaha Hadid, University of Applied Arts Vienna, the bicycle was launched
        </p>
        <p style={{ width: `30%`, marginRight: `18%` }}>
          at Milan Design Week 2015. The unique frame de- sign of this bicycle aims to uncover new possibilities for
          wooden structures. The shape is generated using structural form finding methods.
        </p>
      </div>
      <img src="../pictures/aero/first.jpg" alt="Model posing with the bike"/>
      <img src="../pictures/aero/diagram.png" alt="Diagrams explaining the bike" />
      <div style={{ display: `flex`, flexDirection: `row` }}>
        <p style={{ width: `30%`, marginLeft: `18%` }}>
          Through the simulation of forces that are typical- ly imparted on a bicycle, a catalogue of design solutions
          for the supportive structure was gener- ated. After choosing the most interesting solution in terms of
          handling and design, the shape was remodelled and further analysed using more precise material inputs.
          Replacing conventional
        </p>
        <p style={{ width: `30%`, marginRight: `18%` }}>
          spring solutions, the wooden lamellas of the frame provide lightness, flexibility and strength. Revolutionary
          Composite Wood Carbon Technology was speci cally engineered by Digital Architects and it become the first
          development prototype of the AGM Construction System.
        </p>
      </div>
      <img src="../pictures/aero/second.jpg" alt="The bike in a photostudio"/>
      <Footer />
    </div>
  );
};

export default Page;



// WEBPACK FOOTER //
// ./src/pages/aero.jsx